import React from "react";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <section className="about-us-section" id="about">
      <div className="about-us-content">
        <h2 className="about-us-title">Innovate. Empower. Deliver.</h2>
        <p className="about-us-text">
          <span className="no-break">
            At Softblitz Resources Inc, we specialize in delivering advanced technology solutions that accelerate business transformation.
          </span>{" "}
          <span className="no-break">
            We empower organizations to navigate the complex digital landscape through cutting-edge tools and expert consulting.
          </span>{" "}
          <span className="no-break">
            Our capabilities help streamline operations, enhance security, and unlock real value driving sustainable growth in an ever-evolving world.
          </span>{" "}
          <span className="no-break">
            With a commitment to excellence and partnership, Softblitz Resources Inc is your catalyst for transformation and success.
          </span>
        </p>
      </div>
    </section>
  );
};

export default AboutUs;
